import { useAccountContext } from "~/v2/providers/AccountProvider";
import { Card } from "../../../../v2/components";
import { APIKeys as Other } from "./cards/apiKeys";

export const APIKeys = () => {
  const { product, currentAccount } = useAccountContext();
  return (
    <Card title="API Keys">
      <Other
        key={currentAccount?.id}
        product={product}
        accountID={currentAccount?.id}
      />
    </Card>
  );
};
